import React from 'react';
import { MobileList } from './components/MobileList';
import { DesktopList } from './components/DesktopList';
import { CountrySelectorFooter } from './components/CountrySelectorFooter';
import { CloseButton } from '@components/CloseButton';
import { useFetchCountrySelectListQuery } from './CountrySelector.service';
import { useWinSize } from '@contexts/WinSizeContext';
import './CountrySelector.scss';

interface CountrySelectorProps {
  handleCloseDropdown?: () => void;
}

const CountrySelector = ({ handleCloseDropdown }: CountrySelectorProps) => {
  const { data: countrySelectList } = useFetchCountrySelectListQuery();
  const { isDesktopForHeader: isDesktop } = useWinSize();
  const { isMobileForHeader: isMobileScreen } = useWinSize();
  const isMobile = !isDesktop;

  if (!countrySelectList) return null;

  return (
    <>
      {isMobile || isMobileScreen ? (
        <MobileList
          countries={countrySelectList.Countries}
          title={countrySelectList.Header}
          countrySelectList={countrySelectList}
        />
      ) : (
        <div className='c-country-selector-container'>
          <div className='c-country-selector-header'>
            <div className='c-country-selector-heading'>{countrySelectList.Header}</div>
            <CloseButton onClick={handleCloseDropdown} />
          </div>
          <div className='c-country-selector-info'>{countrySelectList.Introduction}</div>
          {countrySelectList && countrySelectList.I18n && (
            <div className='c-country-selector-block'>
              <DesktopList countries={countrySelectList.Countries} />
              <hr />
              <CountrySelectorFooter
                footerLink={countrySelectList.ContactUsPageLink.Text}
                footerText={countrySelectList.I18n.ContactUsPageText}
                footerLinkHref={countrySelectList.ContactUsPageLink.Href}
                RedirectedIntro={countrySelectList.RedirectedIntro}
                RemoveSettingsText={countrySelectList.RemoveSettingsText}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CountrySelector;
